import React, { useState } from 'react'
// eslint-disable-next-line no-unused-vars
import { FbCheckbox, FbInput, FbSelect, Typography } from '@fabricks/ui-components'
import { get as _get } from "lodash";
import StorageEntryTable from '../StorageEntries/StorageEntryTable'
import { HR } from '../../components/Common/Common'
import {
    BoxTypeDto,
    FilterParam,
    GenericDto,
    useCurrentAvailableBoxTypesQuery,
    useCurrentBoxtypesQuery
} from '../../api/models'
import { useKeycloak } from "react-keycloak";
import { useLocation } from "react-router-dom";
import { getContext, useCustomerGroups, useZones } from "../../services/apiService";
import { useBoxtypes } from "../../services/dataService";
import { Select, MenuItem, FormControl, InputLabel, Box } from "@material-ui/core";

interface DeepInsightProps {}

interface Filter {
    noBoxFilter: boolean
    materialNeedToBePlacedFilter: boolean
    onlyEntriesWithMaterials: boolean
    noAssignment: boolean
    zone: []
    customerGroup: []
    boxType: []
}

export const DeepInsight: React.FC<DeepInsightProps> = () => {
    const [keycloak] = useKeycloak()
    const [searchTerm, setSearchTerm] = useState('')
    const [filter, setFilter] = useState<Filter>({
        noBoxFilter: false,
        materialNeedToBePlacedFilter: new URLSearchParams(useLocation().search).get('filter') === 'placeableMaterials',
        onlyEntriesWithMaterials: false,
        noAssignment: false,
        zone: [],
        customerGroup: [],
        boxType: [],
    })
    const zoneQuery = useZones(keycloak.token, {})
    const customerGroupQuery = useCustomerGroups(keycloak.token)
    const { data: boxTypes } = useCurrentBoxtypesQuery({context: getContext(keycloak.token)})

    const zoneOptions = _get(zoneQuery, 'data.getZones.data', []).map((zoneDto: GenericDto) => ({
        label: zoneDto.value,
        value: zoneDto.uuid,
    }))

    const customerGroupOptions = _get(customerGroupQuery, 'data.getCustomerGroups.data', []).map((cgDto: GenericDto) => ({
        label: cgDto.value,
        value: cgDto.uuid,
    }))

    const boxTypeOptions = _get(boxTypes, 'getBoxTypes.data', []).map((cgDto: BoxTypeDto) => ({
        label: cgDto.name,
        value: cgDto.uuid,
    }))

    const handleSearchChange = (event: any) => {
        setSearchTerm(event.target.value)
    }
    const handleBoxFilterChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFilter({ ...filter, noBoxFilter: event.target.checked })
    }
    const handleStorageEntryFilterChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFilter({ ...filter, materialNeedToBePlacedFilter: event.target.checked })
    }
    const handleMaterialOnlyFilterChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFilter({ ...filter, onlyEntriesWithMaterials: event.target.checked })
    }

    const handleNoAssignmentFilterChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFilter({ ...filter, noAssignment: event.target.checked })
    }

    const handleZoneSelectChange = (
        event: any
    ) => {
        setFilter({ ...filter, zone: event.target.value })
    }

    const handleBoxTypeSelectChange = ( event: any
    ) => {
        setFilter({ ...filter, boxType: event.target.value})
    }

    const handleCustomerGroupSelectChange = (
        event: any
    ) => {
        setFilter({ ...filter, customerGroup: event.target.value })
    }

    const createFilterParams = () => {
        const filterParams: FilterParam[] = []
        if (filter.noBoxFilter) {
            filterParams.push({ custom: 'missingBoxTypes' })
        }
        if (filter.materialNeedToBePlacedFilter) {
            filterParams.push({ custom: 'placeableMaterials' })
        }
        if (filter.onlyEntriesWithMaterials) {
            filterParams.push({ custom: 'onlyWithMaterials' })
        }
        if (filter.noAssignment) {
            filterParams.push({ custom: 'noAssignment' })
        }

        if (filter.zone.length > 0) {
            filterParams.push({ field: 'zone', expected: filter.zone.join(",") })
        }

        if (filter.customerGroup.length > 0) {
            if (filter.noAssignment) {
                filterParams.push({ field: 'storageConfig.customerGroups', expected: filter.customerGroup.join(",") })
            } else {
                filterParams.push({ field: 'material.customerGroup', expected: filter.customerGroup.join(",") })
            }
        }

        if (filter.boxType.length > 0) {
            filterParams.push({ field: 'boxTypeUuid', expected: filter.boxType.join(",") })
        }

        return filterParams
    }

    // @ts-ignore
    return (
        <>
            <FbInput
                id="search"
                label="Search for material"
                className="input"
                value={searchTerm}
                onChange={handleSearchChange}
            />
            <FormControl fullWidth={true} margin={"dense"}>
                <InputLabel id="zone-label">Zones</InputLabel>
                <Select
                    id="zone-select"
                    value={filter.zone}
                    fullWidth={true}
                    label="Zone"
                    multiple={true}
                    onChange={handleZoneSelectChange}>
                    { zoneOptions.map((option: any) =><MenuItem value={option.value}>{option.label}</MenuItem> )}
                </Select>
            </FormControl>

            <FormControl fullWidth={true} margin={"dense"}>
                <InputLabel id="customer-group-select-label">Picking Groups</InputLabel>
                <Select
                    id="customer-group-select"
                    value={filter.customerGroup}
                    fullWidth={true}
                    label="Picking Group"
                    multiple={true}
                    onChange={handleCustomerGroupSelectChange}>
                    { customerGroupOptions.map((option: any) =><MenuItem value={option.value}>{option.label}</MenuItem> )}
                </Select>
            </FormControl>

            <FormControl fullWidth={true} margin={"dense"}>
                <InputLabel id="boxType-select-label">Box types</InputLabel>
                <Select
                    id="boxtype-select"
                    value={filter.boxType}
                    fullWidth={true}
                    label="Box Types"
                    multiple={true}
                    onChange={handleBoxTypeSelectChange}>
                    { boxTypeOptions.map((option: any) =><MenuItem value={option.value}>{option.label}</MenuItem> )}
                </Select>
            </FormControl>
            <Box minHeight={"50px"} />

            <Typography variant="body2">Filter: </Typography>
            <FbCheckbox
                id="boxAssignmentFilter"
                label="Missing box assignment"
                checked={filter.noBoxFilter}
                onChange={handleBoxFilterChange}
            />
            <FbCheckbox
                id="storageNumberFilter"
                label="Placeable materials"
                checked={filter.materialNeedToBePlacedFilter}
                onChange={handleStorageEntryFilterChange}
            />
            <FbCheckbox
                id="storageNumberFilter"
                label="Only entries with materials"
                checked={filter.onlyEntriesWithMaterials}
                onChange={handleMaterialOnlyFilterChange}
            />
            <FbCheckbox
                id="noAssignment"
                label="No assignment"
                checked={filter.noAssignment}
                onChange={handleNoAssignmentFilterChange}
            />
            <HR />
            <StorageEntryTable initLoadingTime={3500} filter={createFilterParams()} searchTerm={searchTerm} />
        </>
    )
}

export default DeepInsight
